import React, { useEffect, useState } from "react";
import img from "../../Images/image (20).png";
import img2 from "../../Images/image (21).png";
import img3 from "../../Images/image (22).png";
import img4 from "../../Images/image (23).png";
import Slider from "react-slick";
import HomeService from "../../Services/HomeService";

const Service = () => {
  const [personalServices, setPersonalServices] = useState([]);

  const fetchPersonalServices = async () => {
    try {
      const res = await HomeService?.getPersonalService();
      console.log("Personal Service", res);
      if (res?.status) {
        setPersonalServices(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPersonalServices();
  }, []);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="signature_properties_wrapper">
        <div className="search_cities_div">
          <div className="search_cities_head_Wrapper45666">
            <h1 className="search_cities_head">Personal Service</h1>
            {/* <button>See More</button> */}
          </div>

          <div className="services_cards_wrapper">
            <Slider {...settings}>
              {personalServices?.map((e, i) => (
                <div className="service_card1">
                  <img src={e?.image} />
                  <div className="service_head_wrapper">
                    <h3>{e?.heading}</h3>
                    {/* <i
                      class="fa-solid fa-arrow-down"
                      style={{
                        transform: "rotate(-130deg)",
                        fontSize: "15px",
                        color: "#ccc",
                      }}
                    ></i> */}
                  </div>
                  <p>{e?.subheading}</p>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default Service;
